<template>
  <div>
    <div class="category-top-bar" ref="optionsTopBar">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" @click="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex"></p>
      </div>
    </div>
    <div class="card mar-to-15 tableInvoice">
      <div class="modal-header">
        <p>
          {{ $t('gestiune.bonFiscal') }}
          <span v-if="tableData.length && tableData[0].nr">
            - Nr: {{ tableData[0].nr }}
          </span>
        </p>

        <!-- Detalii despre bon -->
        <div v-if="tableData.length" class="bon-details">
          <div class="detail-item">
            <span class="label">ID:</span>
            <span class="value">{{ tableData[0]._id }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Data:</span>
            <span class="value">{{ formatDate(tableData[0].date) }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Created at:</span>
            <span class="value">{{ formatDate(tableData[0].created_at) }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Companie:</span>
            <span class="value">{{ tableData[0].externalCompanyId }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Locație:</span>
            <span class="value">{{ tableData[0].externalLocationId }}</span>
          </div>
          <div class="detail-item order">
            <span class="label">Order ID:</span>
            <span class="value" @click.stop="goToOrder(tableData[0])">{{ tableData[0].externalOrderId || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Fiscal:</span>
            <span class="value" :class="tableData[0].is_fiscal ? 'yes' : 'no'">
              {{ tableData[0].is_fiscal ? 'DA' : 'NU' }}
            </span>
          </div>
          <div class="detail-item">
            <span class="label">Tip vânzare:</span>
            <span class="value">{{ formatTipVanzare(tableData[0].tip_vanzare) }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Sursă:</span>
            <span class="value">{{ tableData[0].source }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Tip:</span>
            <span class="value">{{ formatTipVanzare(tableData[0].type) }}</span>
          </div>
        </div>

      </div>
      <div class="card-content">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg><!---->
          </div>
        </div>
        <div class="summary-wrapper">
          <div class="summary-card">
            <div class="label">Total fără discount</div>
            <div class="value">{{ summary.totalWithoutDiscount.toFixed(2) }} lei</div>
          </div>

          <div class="summary-card highlight">
            <div class="label">Total cu discount</div>
            <div class="value">{{ summary.totalWithDiscount.toFixed(2) }} lei</div>
          </div>

          <div class="summary-card">
            <div class="label">Total net (fără TVA)</div>
            <div class="value">{{ summary.totalNet.toFixed(2) }} lei</div>
          </div>

          <div class="summary-card">
            <div class="label">Total TVA</div>
            <div class="value">{{ summary.totalVat.toFixed(2) }} lei</div>
          </div>

          <div class="summary-card danger">
            <div class="label">Total discount</div>
            <div class="value">-{{ summary.totalDiscount.toFixed(2) }} lei</div>
          </div>
        </div>
        <div class="data-table">
          <el-table :data="tableData" style="width: 100%;" border>

            <el-table-column label="ID Produs" width="120">
              <template slot-scope="scope">
                {{ scope.row.productId }}
              </template>
            </el-table-column>

            <el-table-column label="Produs" min-width="120">
              <template slot-scope="scope">
                {{ scope.row.productName }}
              </template>
            </el-table-column>

            <el-table-column label="Cantitate" width="140">
              <template slot-scope="scope">
                {{ scope.row.productQty }} {{ scope.row.productUm || '' }}
              </template>
            </el-table-column>

            <el-table-column label="Preț produs" width="130">
              <template slot-scope="scope">
                {{ scope.row.productOriginalPrice }} lei
              </template>
            </el-table-column>

             <el-table-column label="TVA produs" width="130">
              <template slot-scope="scope">
                {{ scope.row.vat }} %
              </template>
            </el-table-column>

            <el-table-column label="Discount" width="120">
              <template slot-scope="scope">
                {{ scope.row.productDiscount || 0 }}
              </template>
            </el-table-column>

            <el-table-column label="Discount fara tva" width="160">
              <template slot-scope="scope">
                {{ scope.row.productDiscountNet }} lei
              </template>
            </el-table-column>

            <el-table-column label="TVA Discount" width="160">
              <template slot-scope="scope">
                {{ scope.row.productDiscountVat }} lei
              </template>
            </el-table-column>

            <!-- PREȚ FINAL -->
            <el-table-column label="Preț (final)" width="180">
              <template slot-scope="scope">
                {{ scope.row.productPrice }} lei
              </template>
            </el-table-column>

            <el-table-column label="Preț (final) fara TVA" width="180">
              <template slot-scope="scope">
                {{ scope.row.productNetPrice }} lei
              </template>
            </el-table-column>

            <el-table-column label="TVA pret (final)" width="160">
              <template slot-scope="scope">
                {{ scope.row.productVatValue }} lei
                ({{ scope.row.productVatRate }}%)
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
export default {
   // components: {
  //   GeneralTopBar
  // },
  data () {
    return {
      loading: false,
      loadingTimeout: null,
      tableData: []
    }
  },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },
  created () {
    this.companyID = this.$session.get('selectedCompany')
  },
  mounted () {
    console.log('Mounted ManagementBonFiscalView.vue')
    const id = this.route && this.route.params && this.route.params.id
    if (id) {
      this.fetchBonFiscalById(id)
    }
  },
  computed: {
    summary () {
      const rows = this.tableData || []

      const totalQty = rows.reduce((s, r) => s + (Number(r.productQty) || 0), 0)

      const totalWithoutDiscount = rows.reduce(
        (s, r) => s + (Number(r.productOriginalPrice) * Number(r.productQty || 1)),
        0
      )

      const totalWithDiscount = rows.reduce(
        (s, r) => s + (Number(r.productPrice) * Number(r.productQty || 1)),
        0
      )

      const totalNet = rows.reduce(
        (s, r) => s + (Number(r.productNetPrice) * Number(r.productQty || 1)),
        0
      )

      const totalVat = rows.reduce(
        (s, r) => s + (Number(r.productVatValue) * Number(r.productQty || 1)),
        0
      )

      const totalDiscount = rows.reduce(
        (s, r) => s + (Number(r.productDiscount) || 0),
        0
      )

      return {
        totalQty,
        totalWithoutDiscount,
        totalWithDiscount,
        totalNet,
        totalVat,
        totalDiscount
      }
    }
  },
  methods: {
    goBack () {
      this.$bus.$emit('close-modal')
    },
    goToOrder (row) {
      if (row && row.externalOrderId) {
        this.$router.push('/orders/view/' + row.externalOrderId)
      }
    },
    formatDate (value) {
      if (!value) return ''
      const date = new Date(value)
      return isNaN(date.getTime()) ? '' : date.toLocaleDateString()
    },
    formatTipVanzare (value) {
      if (!value || typeof value !== 'string') return ''

      return value
        .replace(/_/g, ' ')
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    },
    async fetchBonFiscalById (id) {
      this.$bus.$emit('set-loading', true)
      try {
        const params = new URLSearchParams({
          externalCompanyId: this.companyID,
          id: id
        })

        const response = await fetch(
          `${process.env.API_BASE_URL_GESTIUNE}:4443/bons_fiscale/?${params.toString()}`,
          { method: 'GET' }
        )

        const result = await response.json()

        // dacă API-ul returnează un obiect, îl bagi într-un array
        this.tableData = []

        if (Array.isArray(result.bons_fiscale)) {
          result.bons_fiscale.forEach(bon => {
            let rawDataParsed = {}
            try {
              if (bon.raw_data && typeof bon.raw_data === 'string') {
                rawDataParsed = JSON.parse(atob(bon.raw_data))
              }
            } catch (e) {
              console.warn('❗ Eroare la decodare raw_data', e)
            }

            // pentru fiecare produs din bon, creezi un rând
            (bon.products || []).forEach(prod => {
              const productId =
                prod.externalProdId ||
                prod.externalCovId ||
                prod.externalCovSgrId ||
                null

              const grossPrice = Number((prod.price - (prod.pondered_discount_amount || 0)) || 0)
              const vatRate = Number(prod.vat || 0)
              const qty = Number(prod.qty || 1)

              const discount = Number(
                ((prod.product_discount || 0) + (prod.pondered_discount_amount || 0))
              )

              // 🔥 reconstruct original price
              const originalPrice = discount
                ? grossPrice + discount
                : grossPrice

              // TVA din preț final
              const netPrice = vatRate
                ? grossPrice / (1 + vatRate / 100)
                : grossPrice

              const vatValue = grossPrice - netPrice


              // discount fără TVA
              const discountNet = vatRate
                ? discount / (1 + vatRate / 100)
                : discount

              // TVA din discount
              const discountVat = discount - discountNet

              this.tableData.push({
                _id: bon._id,
                created_at: bon.created_at,
                created_timestamp: bon.created_timestamp,

                date: bon.date,
                externalCompanyId: bon.externalCompanyId,
                externalLocationId: bon.externalLocationId,
                externalOrderId: bon.externalOrderId,
                is_fiscal: bon.is_fiscal,
                nr: bon.nr,
                type: bon.type,
                rawDataParsed,
                source: bon.source,
                tip_vanzare: bon.tip_vanzare,

                productId,
                productName: prod.name,
                productQty: qty,
                productUm: prod.um,
                vat: vatRate,

                department_id: prod.department_id || null,

                productDiscountNet: Number(discountNet.toFixed(2)),
                productDiscountVat: Number(discountVat.toFixed(2)),

                // FINAL PRICE
                productPrice: Number(grossPrice.toFixed(2)),
                productTotalPrice: Number((grossPrice * qty).toFixed(2)),

                // TVA
                productVatRate: vatRate,
                productNetPrice: Number(netPrice.toFixed(2)),
                productVatValue: Number(vatValue.toFixed(2)),

                // INFO
                productDiscount: Number(discount.toFixed(2)),
                productOriginalPrice: Number(originalPrice.toFixed(2))
              })
            })
          })
        }
      } catch (error) {
        console.error('❌ Eroare la fetch bon fiscal by ID:', error)
      } finally {
        this.$bus.$emit('set-loading', false)
      }
    }
  }
}
</script>

<style scoped>
.tableInvoice .el-table .cell {
  height: 90px;
}
.bon-details {
  font-size: 14px;
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px 16px;
  background: #fff;
  padding: 10px 14px;
  border-radius: 6px;
  border: 1px solid #eee;
}
.global-loader {
  position: fixed;
  inset: 0;
  z-index: 50000; /* sub modal, dar peste restul */
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Arial', sans-serif;
  color: #fff;
  pointer-events: all;
}

.global-loader p {
  margin-top: 16px;
  font-size: 1.2em;
  letter-spacing: 0.5px;
  animation: pulse 1.5s infinite;
}

/* Spinner animat */
.spinner {
  width: 64px;
  height: 64px;
  border: 8px solid rgba(255, 255, 255, 0.3);
  border-top: 8px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Animatie spinner */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.summary-wrapper {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  margin-top: 10px;
  margin-block: 20px;
}

.summary-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px 16px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.06);
  border: 1px solid #eee;
  transition: all 0.2s ease;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.08);
}

.summary-card .label {
  font-size: 12px;
  color: #888;
  margin-bottom: 6px;
  padding: 0px;
}

.summary-card .value {
  font-size: 18px;
  font-weight: 700;
  color: #222;
}

/* highlight (important total) */
.summary-card.highlight {
  border: 1px solid #409eff;
  background: #f5f9ff;
}

.summary-card.highlight .value {
  color: #409eff;
}

/* discount red */
.summary-card.danger {
  border: 1px solid #ff4d4f33;
  background: #fff5f5;
}

.summary-card.danger .value {
  color: #ff4d4f;
}

/* responsive */
@media (max-width: 1200px) {
  .summary-wrapper {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .summary-wrapper {
    grid-template-columns: 1fr;
  }
}
/* Animatie text */
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}

.detail-item {
  display: flex;
  justify-content: space-between;
  color: #25396F !important;
}

.detail-item .label {
  font-weight: 600;
  color: #25396F !important;
  font-size: 14px;
}

.detail-item .value {
  color: #25396F;
}

.detail-item .value.yes {
  color: #2e7d32; /* verde */
  font-weight: 600;
}

.detail-item .value.no {
  color: #c62828; /* roșu */
  font-weight: 600;
}

.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.left-buttons {
  display: flex;
}

.left-buttons button {
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.right-button {
  margin-left: auto;
}

.button-group {
  display: flex;
  justify-content: flex-end;
}

.button-group .btn {
  margin-right: 10px;
}
.order-id-label {
  background-color: #4CAF50 !important; /* verde intens */
  color: white;
  padding: 3px 8px;
  border-radius: 50px;
  cursor: pointer;
  display: inline-block;
  font-weight: bold;
  font-size: 12px;
  user-select: none;
}
.button-group .btn:last-child {
  margin-right: 0;
}
.detail-item.order .value {
  background-color: #4CAF50 !important;
  color: white;
  padding: 3px 8px;
  border-radius: 50px;
  cursor: pointer;
  display: inline-block;
  font-weight: bold;
  font-size: 12px;
  user-select: none;
  height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Outputs/ManagementBonFiscalView.vue